<template>
    <div class="row request-type-selector__container">
        <div class="col-3 request-type-selector__text">
            <b>La solicitud de persona irregular es para:</b>
        </div>
        <div
            v-for="option in options"
            :key="option.id"
            class="col-3"
        >
            <div class="request-type-selector-option__container">
                <input
                    v-model="model"
                    :id="option.id"
                    type="radio"
                    name="contact"
                    :value="option"
                />
                <label
                    :for="option.id"
                    class="request-type-selector-option__label"
                >
                    <i
                        v-if="option.icon"
                        :class="option.icon"
                        class="ml-3 mr-1 color-orange"
                    >
                    </i>
                    {{ option.label }}
                </label>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    components: {
    },
    props: {
        value: {
            type: Object | null,
            required: true,
            default: () => ({
                id: null,
                label: null,
                name: null,
                icon: null,
            }),
        },
        options: {
            type: Array,
            required: true,
            default: () => ([])
        },
    },
    data() {
        return {
            model: {
                id: null,
                label: null,
                name: null,
                icon: null,
            },
        };
    },
    watch: {
        value: {
            deep: true,
            handler(newValue) {
                this.model = this.options.find(opt => opt.id == newValue.id);
            },
        },
        model: {
            deep: true,
            handler(newValue) {
                this.$emit('input', newValue)
            },
        },
    },
};
</script>

<style type="" scoped>
.request-type-selector__container {
    background-color: #F4F6F3;
    border-radius: 5px;
    padding: 20px;
}

.request-type-selector__text {
    display: flex;
    align-items: center;
}

.request-type-selector-option__container {
    background-color: #fff;
    border-radius: 2px;
    padding: 25px;
}

.request-type-selector-option__label {
    display: flex;
    align-items: center;
}

input[type="radio"] {
  display: none;
}

input[type="radio"]+label:before {
  content: "";
  display: inline-block;
  width: 23px;
  height: 23px;
  padding: 4px;
  background-clip: content-box;
  border: 2px solid #bbbbbb;
  border-radius: 50%;
}

input[type="radio"]:checked + label:before {
  background-color: #2db782;
}
</style>